import { render, staticRenderFns } from "./Tweets.vue?vue&type=template&id=a68b9998&"
import script from "./Tweets.vue?vue&type=script&lang=js&"
export * from "./Tweets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports